import type { FunctionComponent, ReactNode } from 'react';

import NotificationWrapper from 'primitives/NotificationWrapper/NotificationWrapper';

export const HOURS_ERROR_MESSAGE = 'Please resolve the errors with your hours.';

type HoursErrorBannerProps = {
  children?: ReactNode;
  closeButtonLabel?: string;
  onClose: () => void;
};

/** Points the user at the row tooltips that say what is wrong with their hours. */
export const HoursErrorBanner: FunctionComponent<HoursErrorBannerProps> = ({
  children = HOURS_ERROR_MESSAGE,
  closeButtonLabel = 'Dismiss',
  onClose,
}) => (
  <NotificationWrapper
    closeButtonLabel={closeButtonLabel}
    indicator
    onClose={onClose}
    role="alert"
    variant="caution"
  >
    {children}
  </NotificationWrapper>
);
